var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-layout"},[_vm._m(0),_c('div',{staticClass:"right-dialog"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-bg"},[_c('img',{staticClass:"left-bg-img",attrs:{"alt":"header-logo","src":require("../assets/background.png")}})])
}]

export { render, staticRenderFns }